
export class ReservationStatus{
    id:number;
    name:string;
}